import { render, staticRenderFns } from "./lisaa-kurssikoodi.vue?vue&type=template&id=0810a88e&scoped=true&"
import script from "./lisaa-kurssikoodi.vue?vue&type=script&lang=ts&"
export * from "./lisaa-kurssikoodi.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-kurssikoodi.vue?vue&type=style&index=0&id=0810a88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810a88e",
  null
  
)

export default component.exports